import http from '@/helpers/Http';

export default {
    namespaced: true,
    state: {
        items: {
            data: [],
            links: {},
            meta: {},
        }
    },
    getters: {
        items: state => state.items,
    },
    mutations: {
        setItems(state, items) {
            state.items = items;
        }
    },
    actions: {
        async index({ commit, rootState }) {
            const response = await http.get('sms', {params: rootState.route.query});

            commit('setItems', response.data);

            return response;
        },
        async store({ commit }, payload) {
            const response = await http.post('sms', payload);

            return response;
        },
        async resend({ commit }, id) {
            const response = await http.post(`sms/${id}/resend`);

            return response;
        },
        async delete({ commit }, id) {
            const response = await http.delete(`sms/${id}`)

            return response;
        }
    }
}